module.exports = __webpack_public_path__ + "a5e5bd7ec2df63e2b21d094312e631d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/file-nf.svg
// module id = 624
// module chunks = 0